module.exports = __webpack_public_path__ + "img/close-icon.b503f44f.svg";